export const SALES_SOURCES = [
    { value: 'ims', label: 'IMS' },
    { value: 'wingpro', label: 'wingpro' },
]